import React, { useState, useEffect } from 'react';
import { Button, Card, Modal, Row, Col, Form, Table, Pagination, Container } from 'react-bootstrap';
import axios from 'axios';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { var_api } from '../../constant';
import Swal from "sweetalert2";
import Loader from "../Loader";

function getFormattedDate(daysBeforeToday) {
    const date = new Date();
    date.setDate(date.getDate() - daysBeforeToday);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

const CouponList = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(25);
  const [popupLast30Days, setPopupLast30Days] = useState(false);
  const [startDate, setStartDate] = useState(getFormattedDate(30));
  const [endDate, setEndDate] = useState(getFormattedDate(0));
  const [clientsData, setClientsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  useEffect(() => {
    fetchClients();
    setCurrentPage(1);
  }, [searchQuery, startDate, endDate]);


  const fetchClients = async () => {
    try {
      setLoading(true);
      // const id = localStorage.getItem('userId');
      const formattedStartDate = formatToDDMMYY(startDate);
      const formattedEndDate = formatToDDMMYY(endDate);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${var_api}/api/coupon-master/coupon-list-report/${formattedStartDate}/${formattedEndDate}`, {
        headers: { Authorization: `${token}` }
      });
      setClientsData(response.data);
      setPopupLast30Days(false);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
    }
  };

  const formatToDDMMYY = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  };

  const filteredUsers = clientsData.filter((client) => {
    const couponName = client.coupon_name ? client.coupon_name.toLowerCase() : "";
    const couponCode = client.coupon_code ? client.coupon_code.toLowerCase() : "";
    const customerName = client.customer_name ? client.customer_name.toLowerCase() : "";
    const customerMobile = client.customer_mobile ? client.customer_mobile.toLowerCase() : "";
    return (
      couponName.includes(searchQuery.toLowerCase()) ||
      couponCode.includes(searchQuery.toLowerCase()) ||
      customerName.includes(searchQuery.toLowerCase()) ||
      customerMobile.includes(searchQuery.toLowerCase())
    );
  });

  const totalPages = Math.ceil(filteredUsers.length / pageSize);
  const paginatedUsers = filteredUsers.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  const exportCouponTableToPDF = () => {
    const doc = new jsPDF();
    const columns = [
      "S.No", "Coupon Name", "Total Coupons", "Used Coupons", "Balance Coupons",
      "Is Unique", "Date", "Coupon Code", "Coupon Count", "Customer Name",
      "Customer Mobile", "Is Discount", "Discount", "Price", "Expires Date",
      "Coupon Status", "Count of Coupon Booking"
    ];
    const rows = paginatedUsers.map((client, index) => [
      index + 1,
      client.coupon_name,
      client.total_coupons,
      client.used_coupons,
      client.balance_coupons,
      client.is_unique,
      client.date,
      client.coupon_code,
      client.coupon_count,
      client.customer_name,
      client.customer_mobile,
      client.is_discount,
      client.discount,
      client.price,
      client.expires_date,
      client.coupon_status === 0 ? 'Active' : 'Inactive',
      client.count_of_coupon_booking
    ]);

    doc.autoTable({ head: [columns], body: rows, theme: 'grid', startY: 10, styles: { fontSize: 8 } });
    doc.save('CouponData.pdf');
  };

  const exportCouponTableToExcel = () => {
    const data = paginatedUsers.map((client, index) => ({
      S_No: index + 1,
      Coupon_Name: client.coupon_name,
      Total_Coupons: client.total_coupons,
      Used_Coupons: client.used_coupons,
      Balance_Coupons: client.balance_coupons,
      Is_Unique: client.is_unique,
      Date: client.date,
      Coupon_Code: client.coupon_code,
      Coupon_Count: client.coupon_count,
      Customer_Name: client.customer_name,
      Customer_Mobile: client.customer_mobile,
      Is_Discount: client.is_discount,
      Discount: client.discount,
      Price: client.price,
      Expires_Date: client.expires_date,
      Coupon_Status: client.coupon_status === 0 ? 'Active' : 'Inactive',
      Count_of_Coupon_Booking: client.count_of_coupon_booking
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Coupon Data");
    XLSX.writeFile(workbook, 'CouponData.xlsx');
  };

  return (
    <>
     {loading && <Loader />} 
    <Container className="activity-container mx-auto">
          <Button variant="dark" onClick={() => history.push('/reports')} className="mb-4">
            <i className='bx bx-arrow-back'></i> Back
          </Button>
          <h2 className="mb-4 text-center">Coupon List</h2>
          <p className="mb-4 text-center">Comprehensive list of all active coupons.</p>

          <div className="filters mb-4 d-flex justify-content-between">
    <Button variant="dark" onClick={() => setPopupLast30Days(true)}>Date Filter</Button>
    <Form.Control
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search"
            style={{ width: '200px' }} // Adjust width as needed
        />
  </div>

          <Modal show={popupLast30Days} onHide={() => setPopupLast30Days(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>Filter Last 30 Days</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row className="mb-4">
                <Col>
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </Col>
                <Col>
                  <Form.Label>End Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </Col>
              </Row>
              <Button variant="dark" onClick={fetchClients}>Apply</Button>
              <Button variant="outline-secondary" onClick={() => setPopupLast30Days(false)} className="ms-2">Cancel</Button>
            </Modal.Body>
          </Modal>

          {/* <div className="d-flex justify-content-end mb-4">
            <Form.Control
              type="text"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search"
            />
          </div> */}

          <Table responsive bordered hover>
            <thead>
              <tr>
                <th>S No</th>
                <th>Coupon Name</th>
                <th>Total Coupons</th>
                <th>Used Coupons</th>
                <th>Balance Coupons</th>
                <th>Is Unique</th>
                <th>Date</th>
                <th>Coupon Code</th>
                <th>Coupon Count</th>
                <th>Customer Name</th>
                <th>Customer Mobile</th>
                <th>Is Discount</th>
                <th>Discount</th>
                <th>Price</th>
                <th>Expires Date</th>
                <th>Coupon Status</th>
                <th>Count Of Coupon Booking</th>
              </tr>
            </thead>
            <tbody>
              {paginatedUsers.length > 0 ? (
                paginatedUsers.map((client, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{client.coupon_name}</td>
                    <td>{client.total_coupons}</td>
                    <td>{client.used_coupons}</td>
                    <td>{client.balance_coupons}</td>
                    <td>{client.is_unique}</td>
                    <td>{client.date}</td>
                    <td>{client.coupon_code}</td>
                    <td>{client.coupon_count}</td>
                    <td>{client.customer_name}</td>
                    <td>{client.customer_mobile}</td>
                    <td>{client.is_discount}</td>
                    <td>{client.discount}</td>
                    <td>{client.price}</td>
                    <td>{client.expires_date}</td>
                    <td className={client.coupon_status === 0 ? 'text-success' : 'text-danger'}>
                      {client.coupon_status === 0 ? 'Active' : 'Inactive'}
                    </td>
                    <td>{client.count_of_coupon_booking}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="17" className="text-center">No Data Available</td>
                </tr>
              )}
            </tbody>
          </Table>
          <div className='d-flex justify-content-between align-items-center mt-4'>
          <div className="d-flex justify-content-start mt-4">
            <Button onClick={exportCouponTableToPDF} variant="dark">Download as PDF</Button>
            <Button onClick={exportCouponTableToExcel} variant="dark" className="ms-2">Download as Excel</Button>
          </div>
          <Pagination className="mt-0">
            <Pagination.Prev onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}>Previous</Pagination.Prev>
            {[...Array(totalPages).keys()].map((_, idx) => (
              <Pagination.Item key={idx} active={currentPage === idx + 1} onClick={() => setCurrentPage(idx + 1)}>
                {idx + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}>Next</Pagination.Next>
          </Pagination>

          </div>
    </Container>
    </>
  );
};

export default CouponList;
